import { useCallback, useEffect } from "react";
import { TableActions } from "../../../components/tables/tableContext/TableContext";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import TableWidget from "../../../components/tables/TableWidget";
import {
  ordersByDeliveryDayTableHeader,
  getOrdersByDeliveryDayTableData,
} from "./tableConfigs/OrdersByDeliveryDayTableConfig";
import { getOrdersByDeliveryDay } from "../../../redux/api/expedition.api";
import { clearOrderByDeliveryDay } from "../../../redux/reducer/expedition.reducer";

import OrdersByDeliveryDayTasksTableActionButtons from "./TableActionsButtonsComponents/OrdersByDeliveryDayTasksTableActionButtons";
import OrdersByDeliveryDayDataHeader from "./components/OrdersByDeliveryDayDataHeader";

function OrdersByDeliveryDay() {
  const dispatch = useAppDispatch();

  const {
    expedition: {
      ordersByDeliveryDay: { data: ordersData, isLoading },
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
  }));

  useEffect(() => {
    return () => {
      dispatch(clearOrderByDeliveryDay());
    };
  }, [dispatch]);

  const handleTableActions = useCallback(
    (action: TableActions) => {
      if (action.tablePagination.page && action.tablePagination.rowsPerPage) {
        const parsedDays = JSON.parse(action.tableSearch.days);
        const isAllDaysSelected = parsedDays?.some(
          (day: { value: number; label: string }) => day.value === 99,
        );
        dispatch(
          getOrdersByDeliveryDay({
            page: action.tablePagination.page,
            perPage: action.tablePagination.rowsPerPage,
            punctLucru: action.tableSearch?.punctLucru ?? "",
            ruta: action.tableSearch?.ruta ?? "",
            livrareZilnic: isAllDaysSelected ? 1 : 0,
            days: action.tableSearch?.days
              ? JSON.parse(action.tableSearch.days)
              : [],
          }),
        );
      }
    },
    [dispatch],
  );

  return (
    <div>
      <TableWidget
        CustomHeaderComponent={OrdersByDeliveryDayDataHeader}
        tableHeaderData={ordersByDeliveryDayTableHeader}
        tableItemsData={getOrdersByDeliveryDayTableData(ordersData.data)}
        tableLoading={isLoading}
        handleTableActions={handleTableActions}
        totalItems={ordersData.total}
        withGlobalSearch={false}
        ActionButtonsComponent={OrdersByDeliveryDayTasksTableActionButtons}
      />
    </div>
  );
}

export default OrdersByDeliveryDay;
